module.exports = __webpack_public_path__ + "static/media/bg20.a98a1d3f.jpg";